"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Opti = void 0;
/**
 * A enum representing the iPro "Opti" property. Some articles have a opti property, some don't.
 */
var Opti;
(function (Opti) {
    /** unmontiert */
    Opti[Opti["unmontiert"] = 1] = "unmontiert";
    /** montiert */
    Opti[Opti["montiert"] = 2] = "montiert";
    /** für alle Größen */
    Opti[Opti["fuer_alle_Groe\u00DFen"] = 1000] = "fuer_alle_Groe\u00DFen";
    /** Standard */
    Opti[Opti["Standard"] = 1001] = "Standard";
    /** Zwei mit Bohrung */
    Opti[Opti["Zwei_mit_Bohrung"] = 1500] = "Zwei_mit_Bohrung";
    /** Zwei mit Bolzen */
    Opti[Opti["Zwei_mit_Bolzen"] = 1501] = "Zwei_mit_Bolzen";
    /** Komplettsatz */
    Opti[Opti["Komplettsatz"] = 1502] = "Komplettsatz";
    /** mit Kettenkamm */
    Opti[Opti["mit_Kettenkamm"] = 1503] = "mit_Kettenkamm";
    /** mit Kettenkamm und Kabelbinder */
    Opti[Opti["mit_Kettenkamm_und_Kabelbinder"] = 1504] = "mit_Kettenkamm_und_Kabelbinder";
    /** mit Bohrung */
    Opti[Opti["mit_Bohrung"] = 1505] = "mit_Bohrung";
    /** mit Bolzen */
    Opti[Opti["mit_Bolzen"] = 1506] = "mit_Bolzen";
    /** kompl. Satz mit Kettenkamm */
    Opti[Opti["kompl_Satz_mit_Kettenkamm"] = 1507] = "kompl_Satz_mit_Kettenkamm";
    /** kompl. Satz mit Kettenkamm und Kabelbinder */
    Opti[Opti["kompl_Satz_mit_Kettenkamm_und_Kabelbinder"] = 1508] = "kompl_Satz_mit_Kettenkamm_und_Kabelbinder";
    /** Komplettsatz inkl. Kämme */
    Opti[Opti["Komplettsatz_inkl_Kaemme"] = 1509] = "Komplettsatz_inkl_Kaemme";
    /** Komplettsatz inkl. Kämme und 10 Kabelbinder */
    Opti[Opti["Komplettsatz_inkl_Kaemme_und_10_Kabelbinder"] = 1510] = "Komplettsatz_inkl_Kaemme_und_10_Kabelbinder";
    /** Kettenkamm und 10 Kabelbinder */
    Opti[Opti["Kettenkamm_und_10_Kabelbinder"] = 1511] = "Kettenkamm_und_10_Kabelbinder";
    /** Kettenkamm für den Kettensteg (fester Steg) */
    Opti[Opti["Kettenkamm_fuer_den_Kettensteg_fester_Steg"] = 1512] = "Kettenkamm_fuer_den_Kettensteg_fester_Steg";
    /** Kettenkamm für den Kettensteg (Öffnungssteg/KMA) */
    Opti[Opti["Kettenkamm_fuer_den_Kettensteg_ffnungssteg_KMA"] = 1513] = "Kettenkamm_fuer_den_Kettensteg_ffnungssteg_KMA";
    /** Kettenkamm für das C-Profil */
    Opti[Opti["Kettenkamm_fuer_das_C_Profil"] = 1514] = "Kettenkamm_fuer_das_C_Profil";
    /** 2 Stück, mit Bohrung */
    Opti[Opti["zwei_Stueck_mit_Bohrung"] = 1515] = "zwei_Stueck_mit_Bohrung";
    /** 2 Stück, mit Bolzen */
    Opti[Opti["zwei_Stueck_mit_Bolzen"] = 1516] = "zwei_Stueck_mit_Bolzen";
    /** kompl. Satz (4 Stück) */
    Opti[Opti["kompl_Satz_4_Stueck"] = 1517] = "kompl_Satz_4_Stueck";
    /** mit C-Profil */
    Opti[Opti["mit_C_Profil"] = 1518] = "mit_C_Profil";
    /** Rinne 2 m Stück */
    Opti[Opti["Rinne_2_m_Stueck"] = 1519] = "Rinne_2_m_Stueck";
    /** Rinne mit Gleitschiene, 2 m Stück */
    Opti[Opti["Rinne_mit_Gleitschiene"] = 1520] = "Rinne_mit_Gleitschiene";
    /** Gleitschiene 2 m Stück */
    Opti[Opti["Gleitschiene_2_m_Stueck"] = 1521] = "Gleitschiene_2_m_Stueck";
    /** Montageset mit C-Profil */
    Opti[Opti["Montageset_mit_C_Profil"] = 1522] = "Montageset_mit_C_Profil";
    /** Montageset ohne C-Profil */
    Opti[Opti["Montageset_ohne_C_Profil"] = 1523] = "Montageset_ohne_C_Profil";
    /** Endset mit C-Profil */
    Opti[Opti["Endset_mit_C_Profil"] = 1524] = "Endset_mit_C_Profil";
    /** Endset ohne C-Profil */
    Opti[Opti["Endset_ohne_C_Profil"] = 1525] = "Endset_ohne_C_Profil";
    /** Befestigungssatz */
    Opti[Opti["Befestigungssatz"] = 1526] = "Befestigungssatz";
    /** 2xRinne, 2m Stück */
    Opti[Opti["zweixRinne_2m_Stueck"] = 1527] = "zweixRinne_2m_Stueck";
    /** 2xRinne mit Gleitschiene, 2m Stück */
    Opti[Opti["zweixRinne_mit_Gleitschiene_2m_Stueck"] = 1528] = "zweixRinne_mit_Gleitschiene_2m_Stueck";
    /** 2xGleitschiene 2m Stück */
    Opti[Opti["zweixGleitschiene_2m_Stueck"] = 1529] = "zweixGleitschiene_2m_Stueck";
    /** Schraubensatz */
    Opti[Opti["Schraubensatz"] = 1530] = "Schraubensatz";
    /** Montageset mit Distanzplatte */
    Opti[Opti["Montageset_mit_Distanzplatte"] = 1531] = "Montageset_mit_Distanzplatte";
    /** Montageset ohne Distanzplatte */
    Opti[Opti["Montageset_ohne_Distanzplatte"] = 1532] = "Montageset_ohne_Distanzplatte";
    /** Komplettsatz mit C-Profil */
    Opti[Opti["Komplettsatz_mit_C_Profil"] = 1533] = "Komplettsatz_mit_C_Profil";
    /** Anschluß-Satz, passend Außenlasche */
    Opti[Opti["Anschlu\u00DF_Satz_passend_Au\u00DFenlasche"] = 1534] = "Anschlu\u00DF_Satz_passend_Au\u00DFenlasche";
    /** Anschluß-Satz, passend Innenlasche */
    Opti[Opti["Anschlu\u00DF_Satz_passend_Innenlasche"] = 1535] = "Anschlu\u00DF_Satz_passend_Innenlasche";
    /** Komplettsatz f. Kette, endend Außenlasche */
    Opti[Opti["Komplettsatz_f_Kette_endend_Au\u00DFenlasche"] = 1536] = "Komplettsatz_f_Kette_endend_Au\u00DFenlasche";
    /** Komplettsatz f. Kette, endend Innenlasche */
    Opti[Opti["Komplettsatz_f_Kette_endend_Innenlasche"] = 1537] = "Komplettsatz_f_Kette_endend_Innenlasche";
    /** Komplettsatz f. Kette, endend Innen-/Außenlasche */
    Opti[Opti["Komplettsatz_f_Kette_endend_Innen_Au\u00DFenlasche"] = 1538] = "Komplettsatz_f_Kette_endend_Innen_Au\u00DFenlasche";
    /** Komplettsatz für ungerade Anzahl Glieder */
    Opti[Opti["Komplettsatz_fuer_ungerade_Anzahl_Glieder"] = 1539] = "Komplettsatz_fuer_ungerade_Anzahl_Glieder";
    /** Komplettsatz für ungerade Anzahl Glieder mit C-Profil */
    Opti[Opti["Komplettsatz_fuer_ungerade_Anzahl_Glieder_mit_C_Profil"] = 1540] = "Komplettsatz_fuer_ungerade_Anzahl_Glieder_mit_C_Profil";
    /** Komplettsatz für gerade Anzahl Glieder */
    Opti[Opti["Komplettsatz_fuer_gerade_Anzahl_Glieder"] = 1541] = "Komplettsatz_fuer_gerade_Anzahl_Glieder";
    /** Komplettsatz für gerade Anzahl Glieder mit C-Profil */
    Opti[Opti["Komplettsatz_fuer_gerade_Anzahl_Glieder_mit_C_Profil"] = 1542] = "Komplettsatz_fuer_gerade_Anzahl_Glieder_mit_C_Profil";
    /** Deckel nur Entnehmbar */
    Opti[Opti["Deckel_nur_Entnehmbar"] = 1543] = "Deckel_nur_Entnehmbar";
    /** lang, mit Bohrung */
    Opti[Opti["lang_mit_Bohrung"] = 1544] = "lang_mit_Bohrung";
    /** lang, mit Bolzen */
    Opti[Opti["lang_mit_Bolzen"] = 1545] = "lang_mit_Bolzen";
    /** lang, kompl. Satz */
    Opti[Opti["lang_kompl_Satz"] = 1546] = "lang_kompl_Satz";
    /** kurz, mit Bohrung */
    Opti[Opti["kurz_mit_Bohrung"] = 1547] = "kurz_mit_Bohrung";
    /** kurz, mit Bolzen */
    Opti[Opti["kurz_mit_Bolzen"] = 1548] = "kurz_mit_Bolzen";
    /** kurz, kompl. Satz */
    Opti[Opti["kurz_kompl_Satz"] = 1549] = "kurz_kompl_Satz";
    /** kompl. Satz, mit Quickflansch */
    Opti[Opti["kompl_Satz_mit_Quickflansch"] = 1550] = "kompl_Satz_mit_Quickflansch";
    /** mit Bohrung, mit Quickflansch */
    Opti[Opti["mit_Bohrung_mit_Quickflansch"] = 1551] = "mit_Bohrung_mit_Quickflansch";
    /** mit Bolzen, mit Quickflansch */
    Opti[Opti["mit_Bolzen_mit_Quickflansch"] = 1552] = "mit_Bolzen_mit_Quickflansch";
    /** mit Bohrung, mit Kettenkamm */
    Opti[Opti["mit_Bohrung_mit_Kettenkamm"] = 1553] = "mit_Bohrung_mit_Kettenkamm";
    /** mit Bolzen, mit Kettenkamm */
    Opti[Opti["mit_Bolzen_mit_Kettenkamm"] = 1554] = "mit_Bolzen_mit_Kettenkamm";
    /** Befestigungssatz für Anschlußelement */
    Opti[Opti["Befestigungssatz_fuer_Anschlu\u00DFelement"] = 1555] = "Befestigungssatz_fuer_Anschlu\u00DFelement";
    /** Busleitung */
    Opti[Opti["Busleitung"] = 1556] = "Busleitung";
    /** low capacity */
    Opti[Opti["low_capacity"] = 1557] = "low_capacity";
    /** Profibus */
    Opti[Opti["Profibus"] = 1558] = "Profibus";
    /** Interbus */
    Opti[Opti["Interbus"] = 1559] = "Interbus";
    /** CAN-BUS/Feldbus */
    Opti[Opti["CAN_BUS_Feldbus"] = 1560] = "CAN_BUS_Feldbus";
    /** DeviceNet */
    Opti[Opti["DeviceNet"] = 1561] = "DeviceNet";
    /** Ethernet/CAT5/GigE */
    Opti[Opti["Ethernet_CAT5_GigE"] = 1562] = "Ethernet_CAT5_GigE";
    /** Ethernet/CAT6A */
    Opti[Opti["Ethernet_CAT6A"] = 1563] = "Ethernet_CAT6A";
    /** für 1 Leitung + Gegenwanne */
    Opti[Opti["fuer_1_Leitung_und_Gegenwanne"] = 1564] = "fuer_1_Leitung_und_Gegenwanne";
    /** für 2 Leitungen + Gegenwanne + Zwischenwanne */
    Opti[Opti["fuer_2_Leitungen_und_Gegenwanne_und_Zwischenwanne"] = 1565] = "fuer_2_Leitungen_und_Gegenwanne_und_Zwischenwanne";
    /** für 3 Leitungen + Gegenwanne + 2 Zwischenwannen */
    Opti[Opti["fuer_3_Leitungen_und_Gegenwanne_und_2_Zwischenwannen"] = 1566] = "fuer_3_Leitungen_und_Gegenwanne_und_2_Zwischenwannen";
    /** Basisleitung */
    Opti[Opti["Basisleitung"] = 1567] = "Basisleitung";
    /** Verlängerungsleitung */
    Opti[Opti["Verlaengerungsleitung"] = 1568] = "Verlaengerungsleitung";
    /** Zwischenleitungen */
    Opti[Opti["Zwischenleitungen"] = 1569] = "Zwischenleitungen";
    /** Klemmkastenanschlußleitung */
    Opti[Opti["Klemmkastenanschlu\u00DFleitung"] = 1570] = "Klemmkastenanschlu\u00DFleitung";
    /** Verbindungsleitung */
    Opti[Opti["Verbindungsleitung"] = 1571] = "Verbindungsleitung";
    /** Systemhalter */
    Opti[Opti["Systemhalter"] = 1572] = "Systemhalter";
    /** Systemhalter mit Bügel */
    Opti[Opti["Systemhalter_mit_Buegel"] = 1573] = "Systemhalter_mit_Buegel";
    /** Polyamid */
    Opti[Opti["Polyamid"] = 1574] = "Polyamid";
    /** Messing */
    Opti[Opti["Messing"] = 1575] = "Messing";
    /** M */
    Opti[Opti["M"] = 1576] = "M";
    /** PG */
    Opti[Opti["PG"] = 1577] = "PG";
    /** ohne C-Profil für alle Breiten */
    Opti[Opti["ohne_C_Profil_fuer_alle_Breiten"] = 1578] = "ohne_C_Profil_fuer_alle_Breiten";
    /** Befestigung innen mit C-Profil */
    Opti[Opti["Befestigung_innen_mit_C_Profil"] = 1579] = "Befestigung_innen_mit_C_Profil";
    /** Befestigung aussen mit C-Profil */
    Opti[Opti["Befestigung_aussen_mit_C_Profil"] = 1580] = "Befestigung_aussen_mit_C_Profil";
    /** mit C-Profil */
    Opti[Opti["mit_C_Profil_"] = 1581] = "mit_C_Profil_";
    /** ohne C-Profil */
    Opti[Opti["ohne_C_Profil"] = 1582] = "ohne_C_Profil";
    /** FireWire */
    Opti[Opti["FireWire"] = 1583] = "FireWire";
    /** Anschlußelement mit Zugenlastung */
    Opti[Opti["Anschlu\u00DFelement_mit_Zugenlastung"] = 1584] = "Anschlu\u00DFelement_mit_Zugenlastung";
    /** Anschlußelement als Zwischenanbindung */
    Opti[Opti["Anschlu\u00DFelement_als_Zwischenanbindung"] = 1585] = "Anschlu\u00DFelement_als_Zwischenanbindung";
    /** Pendellager mit Zugentlastung */
    Opti[Opti["Pendellager_mit_Zugentlastung"] = 1586] = "Pendellager_mit_Zugentlastung";
    /** Pendellager als Zwischenanbindung */
    Opti[Opti["Pendellager_als_Zwischenanbindung"] = 1587] = "Pendellager_als_Zwischenanbindung";
    /** Für Festpunktseite */
    Opti[Opti["Fuer_Festpunktseite"] = 1588] = "Fuer_Festpunktseite";
    /** Für Mitnehmerseite */
    Opti[Opti["Fuer_Mitnehmerseite"] = 1589] = "Fuer_Mitnehmerseite";
    /** Als Zwischenanbindung */
    Opti[Opti["Als_Zwischenanbindung"] = 1590] = "Als_Zwischenanbindung";
    /** Komplettsatz, beidseitige Zugentlastung + 4 Befestigungswinkel */
    Opti[Opti["Komplettsatz_beidseitige_Zugentlastung_und_4_Befestigungswinkel"] = 1591] = "Komplettsatz_beidseitige_Zugentlastung_und_4_Befestigungswinkel";
    /** CC-Link */
    Opti[Opti["CC_Link"] = 1592] = "CC_Link";
    /** USB */
    Opti[Opti["USB"] = 1593] = "USB";
    /** 1 Steuerpaar geschirmt */
    Opti[Opti["ein_Steuerpaar_geschirmt"] = 1594] = "ein_Steuerpaar_geschirmt";
    /** 2 Steuerpaare geschirmt */
    Opti[Opti["zwei_Steuerpaare_geschirmt"] = 1595] = "zwei_Steuerpaare_geschirmt";
    /** Ohne Steuerpaar */
    Opti[Opti["Ohne_Steuerpaar"] = 1596] = "Ohne_Steuerpaar";
    /** 1 Sternvierer geschirmt */
    Opti[Opti["ein_Sternvierer_geschirmt"] = 1597] = "ein_Sternvierer_geschirmt";
    /** Anschlussleitung */
    Opti[Opti["Anschlussleitung"] = 1598] = "Anschlussleitung";
    /** mit Bohrung und C-Profil */
    Opti[Opti["mit_Bohrung_und_C_Profil"] = 1599] = "mit_Bohrung_und_C_Profil";
    /** mit Bolzen und C-Profil */
    Opti[Opti["mit_Bolzen_und_C_Profil"] = 1600] = "mit_Bolzen_und_C_Profil";
    /** GigE */
    Opti[Opti["GigE"] = 1601] = "GigE";
    /** Profinet */
    Opti[Opti["Profinet"] = 1602] = "Profinet";
    /** DVI */
    Opti[Opti["DVI"] = 1603] = "DVI";
    /** 1 Steuertripel geschirmt */
    Opti[Opti["ein_Steuertripel_geschirmt"] = 1604] = "ein_Steuertripel_geschirmt";
    /** Straight */
    Opti[Opti["Straight"] = 1605] = "Straight";
    /** Cross-Over */
    Opti[Opti["Cross_Over"] = 1606] = "Cross_Over";
    /** Ablegerinne 1000mm, einzeln */
    Opti[Opti["Ablegerinne_1000mm_einzeln"] = 1607] = "Ablegerinne_1000mm_einzeln";
    /** Ablegerinne 2000mm, einzeln */
    Opti[Opti["Ablegerinne_2000mm_einzeln"] = 1608] = "Ablegerinne_2000mm_einzeln";
    /** Ablegerinne 1000mm mit Wandkonsole */
    Opti[Opti["Ablegerinne_1000mm_mit_Wandkonsole"] = 1609] = "Ablegerinne_1000mm_mit_Wandkonsole";
    /** Ablegerinne 2000mm mit Wandkonsole */
    Opti[Opti["Ablegerinne_2000mm_mit_Wandkonsole"] = 1610] = "Ablegerinne_2000mm_mit_Wandkonsole";
    /** Wandkonsole, einzeln */
    Opti[Opti["Wandkonsole_einzeln"] = 1611] = "Wandkonsole_einzeln";
    /** Komplettsatz Edelstahl: 1.4301 */
    Opti[Opti["Komplettsatz_Edelstahl_14301"] = 1612] = "Komplettsatz_Edelstahl_14301";
    /** Wellenwiderstand ca. 50 [Ώ] */
    Opti[Opti["Wellenwiderstand_ca_50_Ohm"] = 1613] = "Wellenwiderstand_ca_50_Ohm";
    /** Wellenwiderstand ca. 75 [Ώ] */
    Opti[Opti["Wellenwiderstand_ca_75_Ohm"] = 1614] = "Wellenwiderstand_ca_75_Ohm";
    /** Anschlusselement kurze Zugentlastung */
    Opti[Opti["Anschlusselement_kurze_Zugentlastung"] = 1615] = "Anschlusselement_kurze_Zugentlastung";
    /** Anschlusselement lange Zugentlastung */
    Opti[Opti["Anschlusselement_lange_Zugentlastung"] = 1616] = "Anschlusselement_lange_Zugentlastung";
    /** Komplettsatz Edelstahl f. Kette, endend Außenlasche */
    Opti[Opti["Komplettsatz_Edelstahl_f_Kette_endend_Au\u00DFenlasche"] = 1617] = "Komplettsatz_Edelstahl_f_Kette_endend_Au\u00DFenlasche";
    /** Komplettsatz Edelstahl f. Kette, endend Innen-/Außenlasche */
    Opti[Opti["Komplettsatz_Edelstahl_f_Kette_endend_Innen_Au\u00DFenlasche"] = 1618] = "Komplettsatz_Edelstahl_f_Kette_endend_Innen_Au\u00DFenlasche";
    /** Komplettsatz f. Kette, endend Außenlasche - vormontiert */
    Opti[Opti["Komplettsatz_f_Kette_endend_Au\u00DFenlasche_vormontiert"] = 1619] = "Komplettsatz_f_Kette_endend_Au\u00DFenlasche_vormontiert";
    /** Komplettsatz f. Kette, endend Innen-/Außenlasche - vormontiert */
    Opti[Opti["Komplettsatz_f_Kette_endend_Innen_Au\u00DFenlasche_vormontiert"] = 1620] = "Komplettsatz_f_Kette_endend_Innen_Au\u00DFenlasche_vormontiert";
    /** Komplettsatz Edelstahl f. Kette, endend Außenlasche - vormontiert */
    Opti[Opti["Komplettsatz_Edelstahl_f_Kette_endend_Au\u00DFenlasche_vormontiert"] = 1621] = "Komplettsatz_Edelstahl_f_Kette_endend_Au\u00DFenlasche_vormontiert";
    /** Komplettsatz Edelstahl f. Kette, endend Innen-/Außenlasche - vormontiert */
    Opti[Opti["Komplettsatz_Edelstahl_f_Kette_endend_Innen_Au\u00DFenlasche_vormontiert"] = 1622] = "Komplettsatz_Edelstahl_f_Kette_endend_Innen_Au\u00DFenlasche_vormontiert";
    /** Spindelleitung/Einzelader */
    Opti[Opti["Spindelleitung_Einzelader"] = 1623] = "Spindelleitung_Einzelader";
    /** ASI BUS */
    Opti[Opti["ASI_BUS"] = 1624] = "ASI_BUS";
    /** Hybridleitung */
    Opti[Opti["Hybridleitung"] = 1625] = "Hybridleitung";
    /** Ethernet/CAT7 */
    Opti[Opti["Ethernet_CAT7"] = 1626] = "Ethernet_CAT7";
    /** Ethernet/CAT6 */
    Opti[Opti["Ethernet_CAT6"] = 1627] = "Ethernet_CAT6";
    /** mit Hutschiene */
    Opti[Opti["mit_Hutschiene"] = 1628] = "mit_Hutschiene";
    /** ohne Hutschiene */
    Opti[Opti["ohne_Hutschiene"] = 1629] = "ohne_Hutschiene";
    /** mit Zugentlastung */
    Opti[Opti["mit_Zugentlastung"] = 1630] = "mit_Zugentlastung";
    /** Rechtsgewinde */
    Opti[Opti["Rechtsgewinde"] = 10000] = "Rechtsgewinde";
    /** Linksgewinde */
    Opti[Opti["Linksgewinde"] = 10001] = "Linksgewinde";
})(Opti = exports.Opti || (exports.Opti = {}));
//# sourceMappingURL=Opti.js.map